import { Grid } from '@mui/material';
import { ScreenOrientationType } from '../../../../../hooks/useScreenOrientation';
import {
  CfDataGridCardViewDefinition,
  CfDataGridForStoreDataProps,
  CfDataGridProps,
  NavigableElement,
} from '../../../CfDataGridProps';
import { getHasItems, getItemIds, getItems } from '../../../utility/data-grid-props';
import { CfDataGridNoResultsFound } from '../../DataGridNoResultsFound/CfDataGridNoResultsFound';
import { CfDataGridCard } from '../card/CfDataGridCard';
import { CfDataGridCardByItemId } from '../card/CfDataGridCardByItemId';

export function CfDataGridCardViewBody<TItem, TAppState>(props: {
  dataGridProps: CfDataGridProps<TItem> | CfDataGridForStoreDataProps<TItem, TAppState>;
  cardViewDefinition: CfDataGridCardViewDefinition<TItem>;
  setNavigableElement: (navigableElement: NavigableElement, rowIndex: number, columnIndex: number) => void;
  orientation: ScreenOrientationType;
}): JSX.Element {
  const dataGridProps = props.dataGridProps;

  if (!getHasItems(dataGridProps)) {
    return (
      <Grid container spacing={2}>
        <CfDataGridNoResultsFound
          message={props.dataGridProps.noItemsMessage}
          sx={props.dataGridProps.noItemsMessageSx}
          displayMode='card'
        />
      </Grid>
    );
  } else if ('data' in dataGridProps) {
    return (
      <Grid container spacing={2}>
        {getItems(dataGridProps.data).map(({ item }, index: number) => (
          <CfDataGridCard
            key={item ? dataGridProps.selectId(item) : index}
            item={item}
            cardViewDefinition={props.cardViewDefinition}
            index={index}
            onItemClicked={dataGridProps.onItemClicked}
            hoverStyle={dataGridProps.hoverStyle}
            cursorStyle={dataGridProps.cursorStyle}
            setNavigableElement={props.setNavigableElement}
            orientation={props.orientation}
          />
        ))}
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={2}>
        {getItemIds(dataGridProps.storeData, props.cardViewDefinition.afterItemIds).map(
          ({ itemId, after }, index: number) => (
            <CfDataGridCardByItemId<TItem, TAppState>
              key={itemId ?? index}
              itemId={itemId}
              cardViewDefinition={props.cardViewDefinition}
              index={index}
              itemSelector={dataGridProps.storeData.itemSelector}
              useSelector={dataGridProps.storeData.useSelector}
              onItemClicked={dataGridProps.onItemClicked}
              hoverStyle={dataGridProps.hoverStyle}
              cursorStyle={dataGridProps.cursorStyle}
              setNavigableElement={props.setNavigableElement}
              orientation={props.orientation}
              after={after}
            />
          )
        )}
      </Grid>
    );
  }
}
